import React from 'react';
import { Slide, SlideProps } from '@mui/material';

export const SlideTransition: React.FC<SlideProps> = (props: SlideProps) => {
  return <Slide {...props} direction="up" mountOnEnter unmountOnExit />;
};
